import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M15.003 7.301v6.649c0 .581-.47 1.053-1.053 1.053H2.052A1.053 1.053 0 011 13.95V7.3M8.001 1.525v8.577M4.15 4.85L8.001 1l3.85 3.85" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>);